import { createContext } from 'react';
import { defaultReactiveJob } from "./defaultContext";
import { defaultPlannedJob } from "./defaultContext";

const jobListContext = createContext({
  /**
   * Although it is possible to remove the following I like to keep them here
   * because they help anyone importing AppStateContext to understand what properties/functions
   * this particular context has available
   */

  currentPage: '',
  openJobDetails: false,
  sortBy: '',
  selectedReactiveJob: defaultReactiveJob,

  // To be implemented
  selectedPlannedJob: defaultPlannedJob,

  reactiveJobList: [],
  filteredReactiveJobList: [],
  plannedJobList: [],
  filteredPlannedJobList: [],

  filtersReactive: {
    periodFilter: '',
    slaFilters: '',
    priortiyFilters: '',
    statusFilters: '',
    buildingFilters: [],
    actionFilters: [],
    dateFilter: {},
  },

  filtersPlanned: {
    maintenanceFilter: '',
    statusFilter: '',
    dateFilter: {},
    periodFilter: '',
    buildingFilter: [],
  },

  filtersSchedule: {
    ItemDescription: {},
    ContractNo: {},
  },

  updateOpenJobDetails: open => {},
  updateReactiveJobList: newJobList => {},
  updateFilteredReactiveJobList: newFilteredJobList => {},
  updateFilteredPlannedJobList: newFilteredJobList => {},
  updatePlannedJobList: newJobList => {},
  setAppJobDetails: newJob => {},
  updateSort: sort => {},
  updateReactiveFilters: reactiveFilters => {},
  updatePlannedFilters: plannedFilters => {},
  updateScheduleFilters: scheduleFilter => {},
  updatePlannedAttributes: (attributes: []) => {},
  clearFilters: () => {},
  clearSelectedReactiveJob: () => {},
  clearSelectedPlannedJob: () => {},
  deleteAllJobInfo: () => {},
});

export default jobListContext;
